import React from 'react';
import { FiX } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import SubtasksManager from './SubtasksManager';

const TaskDetailModal = ({ isOpen, onClose, task }) => {
  const navigate = useNavigate();

  if (!isOpen || !task) return null;

  const handleGoToBoard = () => {
    if (task.boardId) {
      navigate(`/boards/${task.boardId}`);
      onClose();
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2 className="modal-title">Task Details</h2>
          <button className="modal-close" onClick={onClose}>
            <FiX size={20} />
          </button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label className="form-label">Task Name</label>
            <div style={{ fontSize: '16px', fontWeight: 600 }}>{task.name}</div>
          </div>
          {task.boardName && (
            <div className="form-group">
              <label className="form-label">Board</label>
              <div>{task.boardName}</div>
            </div>
          )}
          {task.groupName && (
            <div className="form-group">
              <label className="form-label">Group</label>
              <div>{task.groupName}</div>
            </div>
          )}
          <div className="form-group">
            <label className="form-label">Status</label>
            <span className={`status-pill status-${task.status?.toLowerCase().replace(' ', '-')}`}>
              {task.status}
            </span>
          </div>
          <div className="form-group">
            <label className="form-label">Priority</label>
            <span className={`priority-pill priority-${task.priority?.toLowerCase()}`}>
              {task.priority}
            </span>
          </div>
          {task.dueDate && (
            <div className="form-group">
              <label className="form-label">Due Date</label>
              <div>{new Date(task.dueDate).toLocaleDateString()}</div>
            </div>
          )}
          {task.startDate && (
            <div className="form-group">
              <label className="form-label">Start Date</label>
              <div>{new Date(task.startDate).toLocaleDateString()}</div>
            </div>
          )}
          <div className="form-group">
            <label className="form-label">Progress</label>
            <div className="progress-bar">
              <div className="progress-fill" style={{ width: `${task.progress || 0}%` }}></div>
              <span className="progress-text">{task.progress || 0}%</span>
            </div>
          </div>
          
          {task.subtasks && task.subtasks.length > 0 && (
            <div className="form-group">
              <SubtasksManager
                subtasks={task.subtasks}
                onChange={() => {}}
                token={localStorage.getItem('token')}
                editMode={false}
              />
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
          {task.boardId && (
            <button className="btn btn-primary" onClick={handleGoToBoard}>
              Go to Board
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TaskDetailModal;